import type { FaireProductEntity } from "../../entity_types/product";

export const p_ejqryee4wm: FaireProductEntity = {
  token: "p_ejqryee4wm",
  type: "product",
  name: "Moroccan Beldi Glassware - Amber",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/e8d7b60aa1c02f19a02b088b1f29844b9fcfdd241f87c01371a5c78287b63fd7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/665c746819ece7cdf40c6312658ed49ba85a3a2f0cb51d085cfec912a3e14587.jpeg",
    "https://cdn.faire.com/fastly/84c22145cc75956a05179ff15283753c226e0c82bfbdeeae04480afea1c02438.jpeg",
    "https://cdn.faire.com/fastly/a6db4a9fbbd6509edad31830efbc85885f9ccedb1c5212139fba2264cba2d1d8.jpeg",
    "https://cdn.faire.com/fastly/a34b8b95f0a48e73301dbffdc785a329a63d496ae475559651afd8e886fcadbc.jpeg",
  ],
  priceDollars: 4.2,
  description:
    "**Packaged in sets of 6 - 24 single glasses in a master\n\nOur Moroccan glassware is made from recycled wine bottles, beer bottles, jars, or other glass containers. Slight variations in hue/color can arise due to variations in temperature, the amount of glass used, or even the artistic choices made during production. These differences contribute to the unique charm and individual character of each piece. Fun fact: The top-selling beer in Morocco is Heineken, whose iconic green bottles give our green glasses their distinctive shade.\n\nOur Moroccan glassware sets come in four distinct shades. The handblown construction is evident in the bubbles suspended in the glass itself, and the organic forms that the vessels take. Even better, these lovely glasses stack - saving space or making room for lots and lots of them.\n\nCare - Dishwasher safe, but please note: handblown glass is sensitive to drastic temperature changes.\n\nPackaged in sets of 6 in traditional Moroccan gift packaging.\n\n11 fl oz ",
  tags: [],
  msrpDollars: 8.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:25.057Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
